"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortController = exports.FetchResponse = exports.RequestInitForFetch = exports.fetchIso = exports.extractInfoFromResponse = exports.httpFetchWithRetriesAndTimeout = void 0;
const isomorphic_fetch_1 = __importStar(require("isomorphic-fetch"));
exports.fetchIso = isomorphic_fetch_1.default;
Object.defineProperty(exports, "RequestInitForFetch", { enumerable: true, get: function () { return isomorphic_fetch_1.RequestInit; } });
Object.defineProperty(exports, "FetchResponse", { enumerable: true, get: function () { return isomorphic_fetch_1.Response; } });
const p_retry_1 = __importDefault(require("p-retry"));
const abort_controller_1 = __importDefault(require("abort-controller"));
exports.AbortController = abort_controller_1.default;
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
const pino_1 = __importDefault(require("pino"));
const DefaultRetryOptions = {
    retries: 10,
    minTimeout: 500,
    maxTimeout: Math.floor(25000 + 10000 * Math.random()),
};
const DefaultRequestTimeoutMs = 30000;
const MinRequestTimeoutMs = 3000;
const HttpMethodsWithoutRequestBody = new Set(['GET', 'OPTIONS']); // others?
/**
 * Intended for making HTTP requests to APIs, with options for retries and request timeouts.
 *
 *TODO: offer options for fibonacci & power-law backoff. See notes below. (Exponential hits maxTimeout pretty quickly)
 * todo: needs tests. Perhaps use node-fetch's TestServer: https://github.com/node-fetch/node-fetch/blob/main/test/utils/server.js
 *
 * @param args
 */
function httpFetchWithRetriesAndTimeout(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { url, retryOptions, requestBody, requestHeaders, extraOptsForNodeFetch } = args;
        const method = (args.method || 'GET').toUpperCase();
        let requestTimeoutMs = Math.max(MinRequestTimeoutMs, typeof args.requestTimeoutMs === 'number' ? args.requestTimeoutMs : DefaultRequestTimeoutMs);
        let isJsonRequest = args.isJsonRequest;
        const logger = args.logger || pino_1.default();
        const requestOpts = Object.assign({ method }, (extraOptsForNodeFetch || {}));
        if (!HttpMethodsWithoutRequestBody.has(method) && requestBody) { // todo: other methods that must skip body? (eg, OPTIONS?)
            if (typeof requestBody === 'string') {
                requestOpts.body = requestBody;
            }
            else {
                requestOpts.body = fast_safe_stringify_1.default(requestBody);
                isJsonRequest = isJsonRequest === false ? isJsonRequest : true;
            }
        }
        requestOpts.headers = Object.assign({}, requestOpts.headers, requestHeaders);
        if (isJsonRequest) { // or only set if not already present?
            requestOpts.headers['Content-Type'] = 'application/json; charset=utf-8';
        }
        let attemptCount = 0;
        const startTime = Date.now();
        const abbrevUrlForLogging = url.length > 1024 ? `${url.substring(0, 1024)}...` : url;
        const attempt = () => __awaiter(this, void 0, void 0, function* () {
            let resp;
            if (attemptCount === 0) {
                logger.info({
                    method,
                    url: abbrevUrlForLogging,
                }, 'Making http request...');
            }
            else {
                logger.info({
                    method,
                    url: abbrevUrlForLogging,
                    failedAttempts: attemptCount,
                    totalDurationMs: Date.now() - startTime,
                }, 'Making http retry attempt...');
            }
            attemptCount += 1;
            const controller = new abort_controller_1.default();
            const requestTimeout = setTimeout(() => {
                if (!resp) {
                    logger.info({
                        requestTimeoutMs,
                        url: abbrevUrlForLogging,
                        method,
                    }, 'RequestTimeout, request headers not received, aborting.');
                    controller.abort();
                }
            }, requestTimeoutMs);
            resp = yield isomorphic_fetch_1.default(url, Object.assign(Object.assign({}, requestOpts), { signal: controller.signal }));
            clearTimeout(requestTimeout);
            logger.debug({
                status: resp.status,
                url: abbrevUrlForLogging,
                method,
                requestFn: 'httpFetchWithRetriesAndTimeout'
            }, 'Response headers received for request');
            let responseHeaderInfo;
            if (typeof args.abortRetry === 'function' || typeof args.inspectResponseForRetry === 'function') {
                responseHeaderInfo = extractInfoFromResponse(resp.clone());
            }
            if (typeof args.abortRetry === 'function' && args.abortRetry(responseHeaderInfo)) {
                const respInfo = Object.assign(Object.assign({}, responseHeaderInfo), { url: abbrevUrlForLogging });
                logger.info(respInfo, 'Optional abortRetry callback says to stop trying request');
                throw new p_retry_1.default.AbortError('StoppingRetryAttempts');
            }
            if (typeof args.inspectResponseForRetry === 'function') {
                args.inspectResponseForRetry(responseHeaderInfo);
            }
            else if (_isTemporaryTypeOfErrorCode(resp.status)) {
                logger.debug({ status: resp.status, url, method }, 'Should retry request');
                throw new Error(`RetryRequestDesired: ${resp.status} status code`);
            }
            return resp;
        });
        // Options are passed to the retry module (https://github.com/sindresorhus/p-retry)
        //   https://github.com/tim-kos/node-retry#retryoperationoptions
        // Switch to retry that also offers fibonacci or power-law (n^2) backoff calc. This lib only has actual "exponential" backoff (2^n) which tends to reach maxTimeout quickly,
        //  or if maxTimeout is not set, retries less often then desirable in many use cases. Not really much different from setTimeout with max attempts.
        // A power-law shape (n^2) is often desirable. So too Fibonacci, though it is similar to exponential for higher attempt counts it has a nice shape in the early ones.
        return p_retry_1.default(attempt, retryOptions || DefaultRetryOptions);
    });
}
exports.httpFetchWithRetriesAndTimeout = httpFetchWithRetriesAndTimeout;
/**
 * Treats http status codes of 501 through 504 as short term errors, the server might recover.
 * 500 internal-error will usually have the same result when retried so skipping that.
 * With this, the most common case of 502 is retried. (The ingres/gateway/proxy is up but app/api server isn't yet ready or temporarily not responding.)
 *
 * @param statusCode
 */
function _isTemporaryTypeOfErrorCode(statusCode) {
    // 500 likely not temporary, same request will likely have same result. 501-504 505 and higher not used currently but if so, are also not of short term type
    return typeof statusCode === 'number' && statusCode > 500 && statusCode < 505;
}
function extractInfoFromResponse(resp, infoFromRequest) {
    const { status, statusText, headers, ok, redirected, url } = resp;
    return {
        headers: headers.raw(),
        ok,
        redirected,
        statusCode: status,
        statusText,
        method: infoFromRequest && infoFromRequest.method,
        url,
    };
}
exports.extractInfoFromResponse = extractInfoFromResponse;
//# sourceMappingURL=http-fetch-with-retries-and-timeout.js.map